import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LOCATION_INITIALIZED } from '@angular/common';
import { Logger } from './shared/services/logger.service';
import { environment } from '../environments/environment';
/**
 * Handles missing translations
 */
var MyMissingTranslationHandler = (function () {
    function MyMissingTranslationHandler() {
    }
    /**
     * Handle of missing translations
     * @param {MissingTranslationHandlerParams} params Missing translation handler params
     */
    MyMissingTranslationHandler.prototype.handle = function (params) {
        if (environment.production) {
            return; // Display string from default language
        }
        else {
            Logger.error('Missing string (key: ' + params.key + ', language: ' + params.translateService.currentLang + ')');
            return; // Can be modified if it should not display the default language string
        }
    };
    return MyMissingTranslationHandler;
}());
export { MyMissingTranslationHandler };
/**
 * Http Loader
 * @param {HttpClient}            http HttpClient
 * @returns {TranslateHttpLoader} TranslateHttpLoader
 */
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}
/**
 * Lets the app wait until the language files are loaded. After that, it is safe to use the function 'translate.instant'.
 * @param {TranslateService}      translate TranslateService
 * @param {Injector}              injector Injector
 * @returns {() => Promise<any>}
 */
export function appInitializerFactory(translate, injector, userService) {
    return function () { return new Promise(function (resolve) {
        var locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
        locationInitialized.then(function () {
            var langToSet = 'de';
            translate.setDefaultLang(langToSet);
            translate.use(langToSet).subscribe(function () {
                // Language loaded successfully
            }, function () {
                Logger.error('Problem with \'' + langToSet + '\' language initialization.');
            }, function () {
                resolve(null);
            });
            userService.currentUser.subscribe(function (user) {
                if (user) {
                    translate.use(user.language);
                    translate.setDefaultLang(user.language);
                    /** Set HTML Lang for Accessibility */
                    document.querySelector('html').setAttribute('lang', user.language);
                }
            });
        });
    }); };
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/app-translations.ts.pre-build-optimizer.js